
import { computed, defineComponent } from 'vue';
import {
  CustomerShareCampaignParsed,
  ShareCampaignGoal,
  ShareCampaignParsed,
  ShareCampaignSettings,
} from '@comsbi/common/src/types/models';
import { datetimeFormat } from '@/utils';
import dayjs from 'dayjs';

export default defineComponent<{
  campaign?: CustomerShareCampaignParsed;
  master?: ShareCampaignParsed;
  gotStamp: boolean;
}>({
  name: 'ShareCampaignPageContents',

  components: {},

  props: {
    campaign: {
      type: Object,
      default: () => null,
    },
    master: {
      type: Object,
      default: () => null,
    },
    gotStamp: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const settings = computed<ShareCampaignSettings | undefined>(() => props.master?.settings);

    const stamps = computed(() => props.campaign?.contents.stamps);
    const findGoal = (stampNumber: number) => props.master?.settings.goals.find(v => v.numOfStamps === stampNumber);
    const findStamp = (key: string) => props.campaign?.contents.stamps.find(v => v.itemKey === key);

    // CS-7533 n周対応
    const repeatRoundEnabled = computed(() => settings.value?.repeatRoundEnabled ?? false);
    const numOfStamps = computed(() => props.campaign?.contents.stamps.length || 0);
    const maxOfStamps = computed(() => {
      return props.master ? Math.max(...props.master?.settings.goals.map(v => v.numOfStamps)) : 0;
    });
    const numOfClearedRounds = computed(() => Math.floor(numOfStamps.value / maxOfStamps.value));
    const displayRound = computed(() => 1 + Math.max(0, Math.floor((numOfStamps.value - 1) / maxOfStamps.value)));
    const numOfStampsAtRound = computed(() => {
      if (!repeatRoundEnabled.value) return numOfStamps.value;
      return numOfStamps.value - (displayRound.value - 1) * maxOfStamps.value;
    });

    const nextGoal = computed(() => {
      const curr = numOfStampsAtRound.value || 0;
      return props.master?.settings.goals
        .sort((a: ShareCampaignGoal, b: ShareCampaignGoal) => a.numOfStamps - b.numOfStamps)
        .find((v: ShareCampaignGoal) => v.numOfStamps > curr);
    });

    const termEnabled = computed(() => {
      if (!settings.value?.term) return true;
      const [from, to] = settings.value.term;
      const now = dayjs();
      if (from && now.isBefore(from)) return false;
      if (to && now.isAfter(to)) return false;
      return true;
    });

    return {
      settings,

      stamps,
      findGoal,
      findStamp,
      repeatRoundEnabled,
      numOfStamps,
      maxOfStamps,
      displayRound,
      numOfStampsAtRound,
      nextGoal,
      termEnabled,

      // debug
      datetimeFormat,
    };
  },
});
